import React from "react";

const BlogLayout = ({ title, shares, sections }) => {

  const renderSectionContent = (section) => {
    return (
      <>
        {section.content && <p>{section.content}</p>}

        {section.content2 && <p>{section.content2}</p>}

        {section.list && section.list.length > 0 && (
          <ul>
            {section.list.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        )}
      </>
    );
  };

  return (
    <section className="blog-details">
      <div className="container">

        {/* BLOG INTRO */}
        <div className="blog_box_mbr">
          <div className="blog_box_a">
            <h2>{title}</h2>

            {shares && (
              <p className="blog_contents">
                <b>{shares}</b>
              </p>
            )}

            {renderSectionContent(sections[0])}
          </div>

          <div className="blog_box_b">
            <img src={sections[0].image} alt="" />
          </div>
        </div>

        {/* OTHER SECTIONS */}
        {sections.slice(1).map((section, index) => (
          <div className="blog_box_mbr" key={index}>
            {index % 2 === 0 ? (
              <>
                <div className="blog_box_b">
                  <img src={section.image} alt="" />
                </div>

                <div className="blog_box_a blog_box_c">
                  {section.heading && <h2>{section.heading}</h2>}
                  {renderSectionContent(section)}
                </div>
              </>
            ) : (
              <>
                <div className="blog_box_a">
                  {section.heading && <h2>{section.heading}</h2>}
                  {renderSectionContent(section)}
                </div>

                <div className="blog_box_b">
                  <img src={section.image} alt="" />
                </div>
              </>
            )}
          </div>
        ))}

      </div>
    </section>
  );
};

export default BlogLayout;
